function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols/Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon/Fare/4.-Helsefare",
  transform: "translate(4.000000, 4.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(-4.000000, -4.000000)"
}, React.createElement("path", {
  d: "M16.0386623,18.9777836 C15.0613508,18.9777836 14.2692197,19.8147672 14.2692197,20.847423 C14.2692197,21.8800787 15.0613508,22.7170623 16.0386623,22.7170623 C17.0159738,22.7170623 17.8081049,21.8800787 17.8081049,20.847423 C17.8081049,19.8150295 17.0159738,18.9777836 16.0386623,18.9777836",
  id: "Fill-4909",
  fill: "#0A0B09"
}), React.createElement("path", {
  d: "M13.7325902,9.19024262 C13.7325902,9.21017705 13.7336393,9.23011148 13.7349508,9.2500459 L13.733377,9.2500459 L13.7354754,9.26289836 C13.7391475,9.3143082 13.7467541,9.36466885 13.7577705,9.41424262 L14.8531148,16.8070295 C14.8914098,17.4365377 15.4073443,17.9351607 16.0386885,17.9351607 C16.6663607,17.9351607 17.1799344,17.4420459 17.2232131,16.8175213 L18.3167213,9.4260459 C18.3300984,9.36991475 18.3384918,9.31247213 18.3421639,9.25450492 L18.3426885,9.2500459 L18.3424262,9.2500459 C18.3434754,9.23011148 18.3445246,9.21017705 18.3445246,9.19024262 C18.3445246,8.35220984 17.3121311,7.67260328 16.0386885,7.67260328 C14.7649836,7.67260328 13.7325902,8.35194754 13.7325902,9.19024262",
  id: "Fill-4911",
  fill: "#0A0B09"
}), React.createElement("path", {
  d: "M-7.10542736e-15,15.9262951 L15.9260328,31.8531148 L31.8523279,15.9262951 L15.9260328,0 L-7.10542736e-15,15.9262951 Z M29.3287869,15.9262951 C28.2250492,17.0300328 17.0297705,28.2255738 15.9260328,29.3293115 C14.8225574,28.2255738 3.62727869,17.0297705 2.52354098,15.9262951 C3.62727869,14.8228197 14.8222951,3.62727869 15.9260328,2.52354098 C17.0295082,3.62727869 28.2250492,14.8228197 29.3287869,15.9262951 L29.3287869,15.9262951 Z",
  id: "Fill-4913",
  fill: "#D8232A"
}))));

var SvgHealthWarning = function SvgHealthWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHealthWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/health-warning.a069bd26.svg";
export { ForwardRef as ReactComponent };